/*
import {
  hf,
  hfDTM,
  ht,
  cr,
  a,
  BoxC,
  HtyC,
  IptC,
  LblC,
  SrlC,
  GridC,
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as SrlC from "./_ccbSrlC";
import * as GridC from "./_cccGridC";
import * as HtyC from "./_ccmHtyC";
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as _cv_10___Mz from "./_cv_10___Mz";
import * as _cv_31___Mz from "./_cv_31___Mz";
import * as _cv_40___Mz from "./_cv_40___Mz";
import * as ht from './_ht';

import * as icvI10___Ci from './icvI10___Ci';

export const N = (pz: {
  sPz: ht.dz,
}) => {

  return (
    cr.c(BoxC.N, {
      key: -101,
      abtType: 'bdyCmnz',
      oClds: [

        cr.c(GridC.N, {
          key: -102,
          abtType: 'barFtnStfz',
          boxStlz: a(`mb/2`),
          lineCs: [{
            cellCs: [
              {
                oClds: [
                ]
              },
              {
                oClds: [
                ]
              },
              {
                oClds: [
                  cr.c(HtyC.N, {
                    key: -103,
                    sPz: pz.sPz,
                    cz: {
                      elm: 'i10r',
                    }
                  })
                ]
              }
            ]
          }]
        }),

        cr.c(BoxC.N, {
          key: -204,
          abtType: 'cttCmnz',
          oClds: [

            cr.c(SrlC.V, {
              key: -205,
              abtType: 'cttCmnz',
              oClds: [

                cr.c(icvI10___Ci.D, {
                  key: -106,
                  sPz: pz.sPz,
                })

              ],
            }),

            cr.c(icvI10___Ci.B, {
              key: -307,
              sPz: pz.sPz,
              cz: {
                lblz: pz.sPz.crt.lblz,
                sc: 'gn7',
              },
            })

          ]
        })

      ]
    })
  );
};

